import { render, staticRenderFns } from "./Dashboard-v3.vue?vue&type=template&id=15d1b451&"
import script from "./Dashboard-v3.vue?vue&type=script&lang=js&"
export * from "./Dashboard-v3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports